import React, { useEffect, useState } from 'react';
import {
  Elements,
  StripeProvider
} from "react-stripe-elements";

import { getStripePublishableKey } from "../../common/utils/config";
import Confirmation from "./components/Confirmation";
import StripeScriptLoader from '../../common/components/StripeScriptLoader/StripeScriptLoader';

export default function App() {
  return (
    <StripeScriptLoader
      className="pro-landing-message"
      uniqueId='stripe-js'
      script='https://js.stripe.com/v3/'
      loader="Connecting to Stripe..."
    >
      <StripeProvider apiKey={getStripePublishableKey()}>
        <Elements>
          <Confirmation />
        </Elements>
      </StripeProvider>
    </StripeScriptLoader>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/subscription_confirmation/index.js